import { Helmet } from 'react-helmet-async';

import { useLocation } from 'react-router-dom';

import {
  useSeoQuery,
  useSeoEnterpriseQuery,
  useSeoClassCodeQuery,
} from 'common/apollo/graphql';
import useAuth from 'common/hooks/useAuth';

function Seo() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const classroomId =
    location.pathname.match(
      /classrooms\/(?!new\b|registration\b)([^/]+)/
    )?.[1] || (query.get('classroomId') as string);
  const enterpriseId = query.get('enterprise_id');
  const code = query.get('code');

  const { data: { classCode } = {}, loading: classCodeLoading } =
    useSeoClassCodeQuery({
      variables: {
        code: code as string,
      },
      skip: !code || !isAuthenticated,
      fetchPolicy: 'cache-first',
    });

  const { loading: classroomLoading, data: { classroom } = {} } = useSeoQuery({
    variables: {
      classroomId: classroomId || (classCode?.classroomId as string),
    },
    skip: (!classroomId && !classCode?.classroomId) || !isAuthenticated,
  });

  const { loading: enterpriseLoading, data: { enterprise } = {} } =
    useSeoEnterpriseQuery({
      variables: {
        enterpriseId:
          (classroom?.enterpriseId as string) || (enterpriseId as string),
      },
      skip: (!classroom?.enterpriseId && !enterpriseId) || !isAuthenticated,
      fetchPolicy: 'cache-first',
    });

  const isWhiteLabeled = enterprise?.isWhiteLabeled;

  const totalLoading =
    classroomLoading || enterpriseLoading || classCodeLoading;

  return (
    <div>
      {!totalLoading && isAuthenticated && (
        <Helmet
          defaultTitle={
            isWhiteLabeled && enterprise?.branding?.name
              ? (enterprise?.branding?.name as string)
              : '클래스 - Classting'
          }
          titleTemplate={
            isWhiteLabeled && enterprise?.branding?.name
              ? `%s | ${enterprise?.branding?.name}`
              : '%s - Classting'
          }
        >
          <link
            rel="icon"
            href={
              isWhiteLabeled
                ? (enterprise?.branding?.appIconUrl as string)
                : 'favicon.ico'
            }
          />
        </Helmet>
      )}
    </div>
  );
}

export default Seo;
